import React from 'react';
import Modal from '../../../../components/Modal';

/**
 * ConfirmationModal - Generisk bekräftelsedialog
 * Används för att bekräfta kritiska aktioner eller varningar
 * 
 * @param {boolean} isOpen - Om modalen är öppen
 * @param {function} onClose - Callback när modalen stängs
 * @param {function} onConfirm - Callback när användaren bekräftar
 * @param {string} title - Titel på modalen
 * @param {string} message - Huvudmeddelande
 * @param {string} subMessage - Extra förklarande text (optional)
 * @param {string} confirmText - Text på bekräfta-knappen (default: "Fortsätt")
 * @param {string} cancelText - Text på avbryt-knappen (default: "Avbryt")
 * @param {string} variant - Stil-variant: 'warning' | 'danger' | 'info' (default: 'warning')
 */
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  subMessage,
  confirmText = 'Fortsätt',
  cancelText = 'Avbryt',
  variant = 'warning',
}) => {
  // Variant-baserade färger
  const variantStyles = {
    warning: {
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      buttonBg: 'bg-orange-600 hover:bg-orange-700',
    },
    danger: {
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      buttonBg: 'bg-red-600 hover:bg-red-700',
    },
    info: {
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      buttonBg: 'bg-blue-600 hover:bg-blue-700',
    },
  };

  const styles = variantStyles[variant] || variantStyles.warning;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex items-center mb-4">
          <div className={`w-12 h-12 ${styles.iconBg} rounded-full flex items-center justify-center mr-4`}>
            <svg className={`w-6 h-6 ${styles.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          </div>
        </div>
        <p className="text-gray-600 mb-6">
          {message}
        </p>
        {subMessage && (
          <p className="text-sm text-gray-500 mb-6">
            {subMessage}
          </p>
        )}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 ${styles.buttonBg} text-white rounded-md transition-colors`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;

